import { isPciPaymentApiEnabled } from 'app/state/app/app-selectors';
import { useSelector } from 'react-redux';
import { buildPaymentApi, PaymentApi } from './paymentResolver';

export const usePaymentApi = (): PaymentApi => {
  const pciPaymentApiEnabled = useSelector(isPciPaymentApiEnabled);
  return buildPaymentApi(pciPaymentApiEnabled);
};
